import getPercent from './getPercent';

/**
 * Maps approvals row data.
 *
 * @param approvals {Immutable.List} Approval list.
 */
export const mapApprovalsRowData = approvals =>
  approvals.map(approval => {
    const percentApproved = `${approval.get('percentApproved')}%`;
    const numberApproved = approval.get('numberApproved');
    const numberOfContacted = approval.get('numberOfContacted');
    const numberOfLeads = approval.get('numberOfLeads');
    const numberOfCc = approval.get('numberOfCc');
    const numberOfVisit = approval.get('numberOfVisit');
    const numberOfOffers = approval.get('numberOfOffers');
    const numberOfLois = approval.get('numberOfLois');
    const numberOfClosed = approval.get('numberOfClosed');

    return approval
      .set('numberApproved', `${numberApproved} (${percentApproved})`)
      .set('numberOfContacted', `${numberOfContacted} (${getPercent(numberOfContacted, numberApproved)}%)`)
      .set('numberOfLeads', `${numberOfLeads} (${getPercent(numberOfLeads, numberApproved)}%)`)
      .set('numberOfCc', `${numberOfCc} (${getPercent(numberOfCc, numberApproved)}%)`)
      .set('numberOfVisit', `${numberOfVisit} (${getPercent(numberOfVisit, numberApproved)}%)`)
      .set('numberOfOffers', `${numberOfOffers} (${getPercent(numberOfOffers, numberApproved)}%)`)
      .set('numberOfLois', `${numberOfLois} (${getPercent(numberOfLois, numberApproved)}%)`)
      .set('numberOfClosed', `${numberOfClosed} (${getPercent(numberOfClosed, numberApproved)}%)`);
  });
